import { Component, OnInit, OnDestroy } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import * as XLSX from "xlsx";

@Component({
  selector: "app-piensoslis",
  templateUrl: "./piensoslis.component.html",
  styleUrls: ["./piensoslis.component.css"],
})
export class piensoslisComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];
  usuarioActual: any;

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  agrupado: any[] = [];
  resul: boolean;
  codigo: number;

  modoLis = 0;
  prifec: string;
  ultfec: string;

  primerafecha: string;
  ultimafecha: string;
  piensos: any[] = [];
  marcasTipos: any[] = [];
  tablaPivotada: any[] = [];

  private piensosSubscription: Subscription | null = null;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    this.usuarioActual = localStorage.getItem("usuarioActual");
    this.codigo = JSON.parse(this.usuarioActual || "{}").codUsu;

    this.srvCentral.consulPiensos("@").subscribe((datos) => {
      const agrupado: any[] = [];

      datos.forEach((d: any) => {
        let marca = agrupado.find((m) => m.ttcodmar === d.ttcodmar);
        if (!marca) {
          marca = {
            ttcodmar: d.ttcodmar,
            ttdesmar: d.ttdesmar,
            tipos: [],
          };
          agrupado.push(marca);
        }
        marca.tipos.push({
          ttcodtip: d.ttcodtip,
          ttdestip: d.ttdestip,
        });
      });

      this.marcasTipos = agrupado;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargarPiensos(): void {
    const fechaDesde = this.formatearFecha(this.primerafecha);
    const fechaHasta = this.formatearFecha(this.ultimafecha);

    if (this.piensosSubscription) {
      this.piensosSubscription.unsubscribe();
    }

    this.piensosSubscription = this.srvCentral
      .listarPiensos(fechaDesde, fechaHasta, 0, this.codigo)
      .subscribe({
        next: (data) => {
          this.piensos = data || [];
          // console.log("Piensos cargados:", this.piensos);
          this.transformarPiensosParaTabla();
        },
        error: (err) => {
          console.error("Error al cargar piensos:", err);
          this.mostrarAviso("Error al cargar los datos de piensos.");
          this.tablaPivotada = [];
        },
      });
  }

  private mostrarAviso(mensaje: string): void {
    const modalRef = this.modalService.open(AvisosComponent);
    modalRef.componentInstance.mensaje = mensaje;
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return "";
    const [year, month, day] = fecha.split("-");
    return `${day}-${month}-${year}`;
  }

  transformarPiensosParaTabla(): void {
    if (
      !this.piensos ||
      this.piensos.length === 0 ||
      this.piensos[0].ttClave === 0
    ) {
      this.tablaPivotada = [];
      return;
    }

    const grupos = new Map<string, any>();

    this.piensos.forEach((item) => {
      const clave = `${item.ttFecha}-${item.ttSocio}-${item.ttExplo}-${item.ttForma}`;

      if (!grupos.has(clave)) {
        const nuevaFila = {
          ttFecha: item.ttFecha,
          ttSocio: item.ttSocio,
          ttNombr: item.ttNombr,
          ttExplo: item.ttExplo,
          ttForma: item.ttForma,
          //
          ttPedido: item.ttPedido,
          ttServido: item.ttServido,
          lineas: [],
          ...this.inicializarCeldas(),
        };
        grupos.set(clave, nuevaFila);
      }

      const fila = grupos.get(clave);

      fila.lineas.push({
        ttSocio: item.ttSocio,
        ttFecha: item.ttFecha,
        ttExplo: item.ttExplo,
        ttMarca: item.ttMarca,
        ttTipo: item.ttTipo,
        ttCanti: item.ttCanti,
        ttForma: item.ttForma,
        ttOrden: item.ttOrden,
        ttPedido: item.ttPedido,
        ttServido: item.ttServido,
      });
      const combo = `${item.ttDesMc} ${item.ttDesTp}`.trim();

      // Buscar si existe esta combinación en marcasTipos
      for (const marca of this.marcasTipos) {
        for (const tipo of marca.tipos) {
          const colKey = `${marca.ttdesmar} ${tipo.ttdestip}`;
          if (colKey === combo) {
            fila[colKey] = item.ttCanti || 0;
            break;
          }
        }
      }
    });

    this.tablaPivotada = Array.from(grupos.values());
  }
  actualizarCampo(fila: any, campo: "ttPedido" | "ttServido"): void {
    fila[campo] = fila[campo] ? 1 : 0;
    // console.log("Actualizando campo:", campo, "en grupo:", fila);

    if (!fila.lineas || fila.lineas.length === 0) {
      console.warn("No hay líneas asociadas a la fila para actualizar.");
      return;
    }

    const lineasActualizar = fila.lineas.map((linea: any) => ({
      ...linea,
      ttPedido: fila.ttPedido,
      ttServido: fila.ttServido,
    }));

    // console.log("Enviando al backend (modo=1):", lineasActualizar);

    this.srvCentral.entregaPiensos(1, lineasActualizar).subscribe({
      next: (resp) => {
        // console.log("Actualización correcta:", resp);
        this.mostrarAviso("Entrega actualizada correctamente");
      },
      error: (err) => {
        console.error("Error actualizando grupo de líneas:", err);
        this.mostrarAviso("Error guardando el cambio de pedido/servido.");
      },
    });
  }

  inicializarCeldas(): { [key: string]: number } {
    const celdas: { [key: string]: number } = {};
    for (const marca of this.marcasTipos) {
      for (const tipo of marca.tipos) {
        const colKey = `${marca.ttdesmar} ${tipo.ttdestip}`;
        celdas[colKey] = 0;
      }
    }
    return celdas;
  }

  obtenerCantidad(fila: any, marca: any, tipo: any): number {
    const clave = `${marca.ttdesmar} ${tipo.ttdestip}`;
    return fila[clave] || 0;
  }
  exportarAExcel(): void {
    if (this.tablaPivotada.length === 0) return;

    const filaMarcas: string[] = ["FECHA", "NOMBRE", "FINCA", "FORMATO"];
    const filaTipos: string[] = ["", "", "", ""];

    for (const marca of this.marcasTipos) {
      for (let i = 0; i < marca.tipos.length; i++) {
        filaMarcas.push(marca.ttdesmar);
      }
      for (const tipo of marca.tipos) {
        filaTipos.push(tipo.ttdestip);
      }
    }

    const filasDatos = this.tablaPivotada.map((fila) => [
      fila.ttFecha,
      fila.ttNombr,
      fila.ttExplo,
      fila.ttForma === 0 ? "Envasado" : "Granel",
      ...this.marcasTipos
        .map((marca) =>
          marca.tipos.map(
            (tipo) => fila[`${marca.ttdesmar} ${tipo.ttdestip}`] || 0
          )
        )
        .reduce((acc, val) => acc.concat(val), []),
    ]);

    const wsData = [filaMarcas, filaTipos, ...filasDatos];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const colWidths = wsData[0].map(() => ({ wch: 12 }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Piensos");

    const fecha = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `piensos_${fecha}.xlsx`);
  }
}
